import React from 'react'

export default function RoutingBackArrow(props) {
  return (
    <svg width={props.width ? props.width : "24"} height={props.height ? props.height : "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5538_5930)">
        <mask id="mask0_5538_5930" maskUnits="userSpaceOnUse" x="0" y="0" width={props.width ? props.width : "24"} height={props.height ? props.height : "24"}>
          <path d="M24 0H0V24H24V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_5538_5930)">
          <path d="M7.30236 11.9994L18.1412 1.16058C18.4077 0.894008 18.4077 0.466495 18.1412 0.199926C17.8746 -0.0666422 17.4471 -0.0666422 17.1805 0.199926L5.85886 11.5215C5.59229 11.7882 5.59229 12.2157 5.85886 12.4822L17.1805 23.7988C17.3112 23.9296 17.4873 24 17.6583 24C17.8293 24 18.0053 23.9346 18.1361 23.7988C18.4027 23.5322 18.4027 23.1047 18.1361 22.8382L7.30236 11.9994Z" fill="#595959" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5538_5930">
          <rect width={props.width ? props.width : "24"} height={props.height ? props.height : "24"} fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
